module.exports = __webpack_public_path__ + "static/img/核算通_迷你版_封面.7b14286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/核算通_迷你版_封面.jpg
// module id = mLEk
// module chunks = 1